// extracted by mini-css-extract-plugin
export var hideEditor = "_s1-2";
export var infoIcon = "_s1-3";
export var label = "_s1-1";
export var labelContainer = "_s1-0";
export var readonlyText = "_s1-4";